import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);


class ContactPage extends React.Component {

	constructor(props) {
		super(props);
    this.state = {};
	}

	render() {
		return <div className={'ContactPage pageContent'}>
			<div className='contactWrapper'>
				<div className='contactBlock'>
					<div className='contactTitle'>Contact Us:</div>
					<div className='contactBody'><a href='mailto:luxury@diamondsdirect.com'>luxury@diamondsdirect.com</a></div>
				</div>
				<div className='contactBlock'>
					<div className='contactTitle'>Set up an appointment:</div>
					<div className='contactBody'><a href='https://diamondsdirect.com/contact-us' target='_blank'>diamondsdirect.com/contact-us</a></div>
				</div>
			</div>
		</div>;
	}
}
export default ContactPage;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const ContactPageContainer = connect(
  mapStateToProps,
  allActionCreators
)(ContactPage);


// WEBPACK FOOTER //
// ./src/components/views/page/ContactPage.jsx